import React, { useState } from 'react'
import axios from 'axios'
import * as Yup from 'yup'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'
import SauceDosingModeForm from './SauceDosingModeForm'

const emptyDosingMode = {
  name: '',
  dosing_pressure_fast: 0,
  dosing_pressure_slow: 0,
}

const SauceDosingModePage = ({ sauceDosingMode: initialDosingMode }) => {
  const [dosingMode, setDosingMode] = useState(initialDosingMode || emptyDosingMode)
  const [saveSuccessful, setSaveSuccessful] = useState<boolean | null>(null)
  const [saveText, setSaveText] = useState('')

  const handleSubmit = (submittedDosingMode, onFinished) => {
    const { dosing_para_fast, dosing_para_slow, ...dosingMode } = submittedDosingMode
    const body = { sauce_dosing_mode: dosingMode }

    const request = !!dosingMode.id ? updateSauceDosingModeRequest(dosingMode.id, body) : createSauceDosingModeRequest(body)
    request
      .then((resp) => {
        setSaveSuccessful(true)
        setSaveText(t('save_successful', { scope: 'sauce_dosing_modes' }))
        onFinished(true, null)
        setDosingMode(resp.data)
      })
      .catch((error) => {
        setSaveSuccessful(false)
        setSaveText(t('save_failed', { scope: 'sauce_dosing_modes' }))
        onFinished(false, error.response.data)
      })
  }

  const createSauceDosingModeRequest = (sauceDosingMode) => {
    return axios.post('/admin/sauce_dosing_modes', sauceDosingMode)
  }

  const updateSauceDosingModeRequest = (id, sauceDosingMode) => {
    return axios.put(`/admin/sauce_dosing_modes/${id}`, sauceDosingMode)
  }

  const renderSaveMessage = () => {
    if (saveText) {
      return (
        <div
          className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}
          role="alert"
        >
          {saveText}
        </div>
      )
    }
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={[!!dosingMode.id ? 'Edit' : 'New', t('sauce_dosing_modes.sauce_dosing_mode')]} />
      </div>
      <div className="card card-robis">
        <div className="row">
          <div className="col-sm-12">
            {renderSaveMessage()}
            <SauceDosingModeForm
              dosingMode={dosingMode}
              onSubmitForm={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default SauceDosingModePage
